import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';
import { fetchBrandItems } from '../../../products/brands/actions';
import { getActiveShopBrandId } from '../../../auth/selectors';

export default compose(
  connect(state => ({
    brandId: getActiveShopBrandId(state),
  }), { fetchBrandItems }),
  withPropsOnChange(['brandId'], (props) => {
    props.fetchBrandItems(props.brandId);
    return {};
  }),
);
